import { render, staticRenderFns } from "./ProductTypeBlock.vue?vue&type=template&id=577ad9c5"
import script from "./ProductTypeBlock.vue?vue&type=script&lang=js"
export * from "./ProductTypeBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports